import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import React from 'react';
import Flex from '../shared-styles/flexi';

function Input({value,label='',placeholder='',error='',width="300px",onChange,...props}) {

  return (
    <Flex direction='column' alignItems='start' gap='6px'>
        <label className="font-bold">{label}</label>
        <InputText style={{'width':width}} {...props} placeholder={placeholder ? placeholder : label} value={value} onChange={(e) => onChange(e.target.value)} required className={classNames({ 'p-invalid': error })} />
        {error && <small className="p-error">{error}</small>}
    </Flex>
  );
}

export default Input;